import styled from 'styled-components';

export const MainFeaturedPostWrapper = styled.div`
`;
